(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["fui"] = factory(require("react"));
	else
		root["fui"] = factory(root["react"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__39155__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 13394:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f=__webpack_require__(39155),k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}__webpack_unused_export__=l;exports.jsx=q;__webpack_unused_export__=q;


/***/ }),

/***/ 39155:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__39155__;

/***/ }),

/***/ 64922:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(13394);
} else {}


/***/ }),

/***/ 69122:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 81301:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"firmColor":"#5d3b84","secondaryColor":"silver","successColor":"#4ab675","i":"src-components-Icon-styles_i","smallIcon":"src-components-Icon-styles_smallIcon","disabled":"src-components-Icon-styles_disabled","greyIcon":"src-components-Icon-styles_greyIcon"});

/***/ }),

/***/ 87083:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Icon_BaseIcon)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(39155);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(69122);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Icon/styles.scss
var styles = __webpack_require__(81301);
;// ./src/components/Icon/BaseIcon/BaseIcon.tsx
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




function BaseIcon(_a) {
    var { icon, src, className, isDisabled = false, onClick = () => null, onMouseEnter = () => null, onMouseLeave = () => null, isSmall = false, isGrey = false, style } = _a, restProps = __rest(_a, ["icon", "src", "className", "isDisabled", "onClick", "onMouseEnter", "onMouseLeave", "isSmall", "isGrey", "style"]);
    const [iconHtml, setIconHtml] = (0,external_react_.useState)(null);
    const isMounted = (0,external_react_.useRef)(false);
    (0,external_react_.useEffect)(() => {
        const controller = new AbortController();
        isMounted.current = true;
        getIconHtml(controller);
        return () => {
            isMounted.current = false;
            controller === null || controller === void 0 ? void 0 : controller.abort();
        };
    }, [icon, src]);
    const getIconHtml = (controller) => __awaiter(this, void 0, void 0, function* () {
        if (src) {
            let iconResponse = yield fetch(src, {
                signal: controller.signal,
            });
            // @ts-ignore
            setIconHtml(yield iconResponse.text());
            // @ts-ignore
            controller = null;
            return;
        }
        let iconHtml = null;
        if (icon) {
            iconHtml = icon;
        }
        // @ts-ignore
        isMounted.current && setIconHtml(iconHtml);
    });
    return ((0,jsx_runtime.jsx)("i", { "data-test": restProps['data-test'], className: classnames_default()(styles/* default */.A.i, className, {
            [styles/* default */.A.disabled]: isDisabled,
            [styles/* default */.A.smallIcon]: isSmall,
            [styles/* default */.A.greyIcon]: isGrey,
        }), 
        // @ts-ignore
        dangerouslySetInnerHTML: { __html: iconHtml }, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, style: style }));
}
/* harmony default export */ const BaseIcon_BaseIcon = (BaseIcon);

;// ./src/components/Icon/BaseIcon/index.ts

/* harmony default export */ const Icon_BaseIcon = (BaseIcon_BaseIcon);


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Icon_IconFileJpg)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: ./src/components/Icon/BaseIcon/index.ts + 1 modules
var BaseIcon = __webpack_require__(87083);
;// ./src/components/Icon/IconFileJpg/file-jpg.inline.svg?raw
/* harmony default export */ const file_jpg_inlineraw = ("<svg focusable=\"false\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.6 0H10L14.8 4.8V7H2V1.6C2 0.72 2.72 0 3.6 0ZM9.2 5.6H13.6L9.2 1.2V5.6Z\"/>\n<path d=\"M7.86393 12.0117H6.96549V10.3711H7.87955C8.12695 10.3737 8.32226 10.4544 8.46549 10.6133C8.60872 10.7721 8.68033 10.9844 8.68033 11.25C8.68033 11.4922 8.61002 11.6797 8.46939 11.8125C8.33137 11.9453 8.12955 12.0117 7.86393 12.0117Z\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 8H16V16H0V8ZM15.3016 14.2969C15.0906 14.5312 14.7821 14.7201 14.3758 14.8633C13.9696 15.0065 13.5242 15.0781 13.0399 15.0781C12.2951 15.0781 11.7 14.8503 11.2547 14.3945C10.8094 13.9388 10.5711 13.3047 10.5399 12.4922L10.536 12C10.536 11.4401 10.6349 10.9518 10.8328 10.5352C11.0307 10.1159 11.3133 9.79427 11.6805 9.57031C12.0503 9.34375 12.4774 9.23047 12.9617 9.23047C13.6701 9.23047 14.2196 9.39323 14.6102 9.71875C15.0034 10.0417 15.2326 10.5247 15.2977 11.168H13.9774C13.9305 10.8503 13.8289 10.6237 13.6727 10.4883C13.5164 10.3529 13.2951 10.2852 13.0086 10.2852C12.6649 10.2852 12.3992 10.431 12.2117 10.7227C12.0242 11.0143 11.9292 11.431 11.9266 11.9727V12.3164C11.9266 12.8841 12.0229 13.3112 12.2156 13.5977C12.411 13.8815 12.7169 14.0234 13.1336 14.0234C13.4904 14.0234 13.756 13.944 13.9305 13.7852V12.9023H12.9774V11.9609H15.3016V14.2969ZM4.88721 9.3125H3.52002V13.2148C3.52002 13.4701 3.46794 13.6693 3.36377 13.8125C3.26221 13.9531 3.11637 14.0234 2.92627 14.0234C2.71533 14.0234 2.56429 13.9648 2.47314 13.8477C2.3846 13.7305 2.34033 13.5417 2.34033 13.2812H0.965332C0.965332 13.8542 1.13721 14.2969 1.48096 14.6094C1.82471 14.9219 2.30648 15.0781 2.92627 15.0781C3.29606 15.0781 3.6307 15 3.93018 14.8438C4.23226 14.6875 4.46663 14.4674 4.6333 14.1836C4.80257 13.8997 4.88721 13.5768 4.88721 13.2148V9.3125ZM6.96549 15V13.0703H7.84049C8.5332 13.0703 9.07747 12.9049 9.4733 12.5742C9.87174 12.2409 10.071 11.7969 10.071 11.2422C10.071 10.8672 9.97851 10.5326 9.79361 10.2383C9.61132 9.94141 9.35221 9.71354 9.01627 9.55469C8.68294 9.39323 8.29882 9.3125 7.86393 9.3125H5.59439V15H6.96549Z\"/>\n</svg>\n");
;// ./src/components/Icon/IconFileJpg/IconFileJpg.tsx



const IconFileJpg = (props) => ((0,jsx_runtime.jsx)(BaseIcon["default"], Object.assign({ icon: file_jpg_inlineraw }, props)));
/* harmony default export */ const IconFileJpg_IconFileJpg = (IconFileJpg);

;// ./src/components/Icon/IconFileJpg/index.ts

/* harmony default export */ const Icon_IconFileJpg = (IconFileJpg_IconFileJpg);

})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map